import { ApiClient } from '../../utils/apiClient';
import type { APIConfig } from '../../types';
import { DEFAULT_API_CONFIG } from './config';
import type { CreateSelfServiceApiOptions, SelfServiceApiContext, SelfServiceHttpClient } from './types';

const createDelay = (ms: number): Promise<void> => new Promise(resolve => setTimeout(resolve, ms));

const mergeConfig = (config?: Partial<APIConfig>): APIConfig => {
  const delays = {
    ...DEFAULT_API_CONFIG.delays,
    ...(config?.delays ?? {})
  };

  return {
    ...DEFAULT_API_CONFIG,
    ...(config ?? {}),
    delays
  };
};

export const createContext = (options: CreateSelfServiceApiOptions = {}): SelfServiceApiContext => {
  const config = mergeConfig(options.config);
  const baseUrl = options.config?.baseUrl ?? '/api';
  const httpClient: SelfServiceHttpClient = options.httpClient ?? ApiClient;

  return {
    config,
    baseUrl,
    httpClient,
    delay: createDelay
  };
};



